import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if ('serviceWorker' in navigator && environment.production) {
  navigator.serviceWorker.register('/ngsw-worker.js').then(() => {
    console.log('Service Worker Registered');
  });
}

platformBrowserDynamic().bootstrapModule(AppModule, { "preserveWhitespaces": true })
  .catch(err => console.error(err));
